import StepCounter from './StepCounter';

export default StepCounter;